<template>
  <div
    class="header_wrapper"
    :style="{
      background: !selectStatus && sticked ? 'transparent' : '#fafafa',
    }"
  >
    <div class="head_box">
      <div>
        <img
          @click="goUrl('/home', 'inner')"
          :src="
            sticked && !selectStatus
              ? require('../assets/img2/logo_icon_white.png')
              : require('../assets/img2/logo_icon_2x.png')
          "
        />
        <div>
          <div
            @click.stop="goUrl(menu.url, menu.urlType)"
            v-for="(menu, index) in menus"
            :key="index"
            :class="$route.path === menu.url ? 'selected' : ''"
            :style="{ color: sticked && !selectStatus ? 'white' : '#131414' }"
            @mouseenter="selectStatus = true"
            @mouseleave="selectStatus = false"
          >
            {{ menu.name }}
            <div
              v-if="menu.groups && menu.groups.length > 0"
              @click.stop=""
              :class="['submenu_wrapper', 'submenu_wrapper' + index]"
            >
              <div v-for="(group, idx) in menu.groups" :key="idx">
                <span>{{ group.lable }}</span>
                <div
                  @click.stop="
                    goUrl(submenu.url, submenu.urlType, submenu.hashId)
                  "
                  v-for="(submenu, ind) in group.submenus"
                  :key="ind"
                >
                  {{ submenu.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="serarch-box">
        <div>Search</div>
        <img src="../assets/img2/head_search_icon.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  props: ["status"],
  data() {
    return {
      menus: [
        {
          name: "AIDTOOLS",
          url: "/aidtools",
          urlType: "inner",
          groups: [
            {
              lable: "魔估二手车系列（二手车云智能检测仪）",
              submenus: [
                {
                  name: "魔估二手车（6寸）",
                  url: "/aidtools",
                  hashId: "normal",
                  urlType: "inner",
                },
                {
                  name: "魔估二手车X2Pro/S2Pro（8寸）",
                  url: "/aidtools",
                  hashId: "S2Pro",
                  urlType: "inner",
                },
                {
                  name: "魔估二手车X3Pro/S3Pro（8寸）",
                  url: "/aidtools",
                  hashId: "S3Pro",
                  urlType: "inner",
                },
                {
                  name: "魔估二手车Pro（8寸）",
                  url: "/aidtools",
                  hashId: "pro",
                  urlType: "inner",
                },
                {
                  name: "魔估二手车Pro+（10.1寸）",
                  url: "/aidtools",
                  hashId: "pro2",
                  urlType: "inner",
                },
                {
                  name: "估车宝（车商版）",
                  url: "/aidtools",
                  hashId: "guchebao",
                  urlType: "inner",
                },
              ],
            },
            // {
            //   lable: "哮天犬系列（汽车智能诊断设备）",
            //   submenus: [
            //     {
            //       name: "哮天犬1号（基础版）",
            //       url: "/aidtools",
            //       hashId: "dog1",
            //       urlType: "inner",
            //     },
            //     {
            //       name: "哮天犬2号（专业版）",
            //       url: "/aidtools",
            //       hashId: "dog2",
            //       urlType: "inner",
            //     },
            //     {
            //       name: "哮天犬3号（专业增强版）",
            //       url: "/aidtools",
            //       hashId: "dog3",
            //       urlType: "inner",
            //     },
            //   ],
            // },
          ],
        },
        {
          name: "X-431MR",
          url: "/x431mr",
          urlType: "inner",
          groups: [
            {
              lable: "汽车智能诊断设备",
              submenus: [
                {
                  name: "X-431MR",
                  url: "/x431mr",
                  hashId: "normal",
                  urlType: "inner",
                },
                {
                  name: "X-431MR Pro",
                  url: "/x431mr",
                  hashId: "pro",
                  urlType: "inner",
                },
                {
                  name: "X-431MR Pro+",
                  url: "/x431mr",
                  hashId: "pro2",
                  urlType: "inner",
                },
              ],
            },
          ],
        },
        {
          name: "官方商城",
          url: "",
          urlType: "",
          groups: [
            {
              lable: "Shopping mall",
              submenus: [
                {
                  name: "淘宝商城",
                  url: "https://shop205861774.taobao.com/shop/view_shop.htm",
                  urlType: "outer",
                },
                {
                  name: "天猫商城",
                  url: "https://aidituo.tmall.com/search.htm?q=6",
                  urlType: "outer",
                },
                {
                  name: "拼多多",
                  url:
                    "https://mobile.yangkeduo.com/mall_page.html?refer_share_id=SRS39EuBlpYS527AOhxhbBPGXAMmjxmw&refer_share_channel=copy_link&refer_share_uid=4775656748&_wvx=10&mall_id=178359541&_wv=41729&share_uin=6INL6U32MKVM4EE57KSQ7XWUB4_GEXDA&_x_query=%E8%89%BE%E8%BF%AA%E6%8B%93&share_uid=4775656748&refer_share_uin=6INL6U32MKVM4EE57KSQ7XWUB4_GEXDA&msn=mth6evr75v33dtvhzmypcxelsi_axbuy&has_decoration=1&_x_org=2",
                  urlType: "outer",
                },
              ],
            },
          ],
        },
        {
          name: "API商城",
          url: "http://apipass.mingruidata.com/apimall/#/home",
          urlType: "outer",
        },
        {
          name: "软件下载",
          url: "/softwaredownload",
          urlType: "inner",
        },
        // {
        //   name: "数据大屏",
        //   url: "",
        //   urlType: "",
        //   groups: [
        //     {
        //       lable: "DATA SCREEN",
        //       submenus: [
        //         {
        //           name: "明睿数据大屏",
        //           url:
        //             "https://datav.aliyuncs.com/share/035d00a8d2418ead8cf69cb36d376bee",
        //           urlType: "outer"
        //         },
        //         {
        //           name: "元征数据大屏",
        //           url:
        //             "https://datav.aliyuncs.com/share/55a789a9f106ecffdcb4303726cc7200",
        //           urlType: "outer"
        //         },
        //         {
        //           name: "二手车数据大屏",
        //           url:
        //             "https://datav.aliyuncs.com/share/f6804abee94d615fa7a826628cbe8d42",
        //           urlType: "outer"
        //         },
        //         {
        //           name: "PAAS平台大屏",
        //           url:
        //             "https://datav.aliyuncs.com/share/70c139491343ee79f55971155d41b85b",
        //           urlType: "outer"
        //         }
        //       ]
        //     }
        //   ]
        // },
        {
          name: "关于企业",
          url: "/aboutus",
          urlType: "inner",
          groups: [
            {
              lable: "走进明睿",
              submenus: [
                {
                  name: "关于企业",
                  url: "/aboutus",
                  hashId: "corporation",
                  urlType: "inner",
                },
                {
                  name: "合作代理",
                  url: "/agent",
                  hashId: "parter",
                  urlType: "inner",
                },
              ],
            },
          ],
        },
        {
          name: "技术支持",
          url: "/techservice",
          urlType: "inner",
          groups: [
            {
              lable: "来自AIDTOOLS专家的服务与支持",
              submenus: [
                {
                  name: "在线咨询",
                  url: "/techservice",
                  hashId: "footer",
                  urlType: "inner",
                },
              ],
            },
          ],
        },
      ],
      sticked: true,
      selectStatus: false,
    };
  },
  methods: {
    goUrl(url, type, hashId) {
      if (this.$route.path == url) {
        if (hashId) {
          document.getElementById(hashId).scrollIntoView({ block: "center" });
        }
        return;
      }
      switch (type) {
        case "inner":
          if (hashId) {
            this.$router.push({
              path: url,
              query: { hashId: hashId, time: new Date().getTime() },
            });
          } else {
            this.$router.push({ path: url });
          }
          break;
        case "outer":
          window.open(url);
          break;
        case "download":
          this.downloadFile(url, hashId);
          break;
      }
    },
    // 点击下载文件
    downloadFile(path, title) {
      window.open(path);
      return;
      path = path.replace(/^http:/, "https:");
      this.download(path, title);
    },
    download(src, fileName) {
      let x = new XMLHttpRequest();
      x.open("GET", src, true);
      x.responseType = "blob";
      x.onload = function(e) {
        let url = window.URL.createObjectURL(x.response);
        let a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
      };
      x.send();
    },
    compute() {
      if (this.status) {
        let ele = document.getElementById("app");
        if (ele.getBoundingClientRect().top < -80) {
          if (this.sticked == true) {
            this.sticked = false;
          }
        } else {
          if (this.sticked == false) {
            this.sticked = true;
          }
        }
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.compute);
    this.sticked = this.status;
  },
};
</script>
<style lang="less" scoped>
.header_wrapper {
  // position: relative;
  width: 100vw;
  margin: 0px auto;
  position: fixed;
  z-index: 10000;
  top: 0;
}
div .head_box {
  // position: relative;
  width: 1920px;
  margin: 0px auto;
  // background: #f8f8f8;
  display: flex;
  align-items: center;
  top: 0;
  > div:first-child {
    position: relative;
    width: 1330px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    margin-left: 194px;
    > img {
      width: 262px;
      height: 32px;
      cursor: pointer;
    }
    > div {
      width: 970px;
      position: relative;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-between;
      > div.selected {
        &::after {
          position: absolute;
          content: "";
          width: 100%;
          height: 4px;
          background-color: white;
          bottom: 0;
          left: 0;
        }
      }
      > div {
        position: relative;
        line-height: 68px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: white;
        opacity: 1;
        > div.submenu_wrapper {
          display: none;
          position: absolute;
          left: 0;
          // padding-top: 20px;
          // padding-bottom: 30px;
          background: white; // #f8f8f8;
          cursor: default;
          z-index: 100;
          width: 2050px;
          > div {
            position: relative;
            width: 280px;
            > span {
              display: block;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 20px;
              color: #333333;
              opacity: 1;
            }
            > div {
              margin-top: 14px;
              position: relative;
              width: 280px;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 22px;
              color: #333333;
              opacity: 1;
              &:hover {
                cursor: pointer;
              }
            }
          }
          > div + div {
            border-top: 1px solid #e5e5e5;
            margin-top: 20px;
            padding-top: 20px;
          }
        }
        > div.submenu_wrapper0 {
          left: -700px;
          > div {
            left: 700px;
            background: #fafafa;
            padding-top: 20px;
            padding-bottom: 30px;
          }
        }
        > div.submenu_wrapper1 {
          left: -867px;

          > div {
            left: 867px;
            background: #fafafa;
            padding-top: 20px;
            padding-bottom: 30px;
          }
        }
        > div.submenu_wrapper2 {
          left: -1025px;
          > div {
            left: 1025px;
            background: #fafafa;
            padding-top: 20px;
            padding-bottom: 30px;
          }
        }
        > div.submenu_wrapper3 {
          left: -1262px;
          > div {
            left: 1262px;
            background: #fafafa;
            padding-top: 20px;
            padding-bottom: 30px;
          }
        }
        > div.submenu_wrapper4 {
          left: -1434px;
          > div {
            left: 1434px;
            background: #fafafa;
            padding-top: 20px;
            padding-bottom: 30px;
          }
        }
        > div.submenu_wrapper5 {
          left: -1453px;
          > div {
            left: 1453px;
            background: #fafafa;
            padding-top: 20px;
            padding-bottom: 30px;
          }
        }
        > div.submenu_wrapper6 {
          left: -1598px;
          > div {
            left: 1598px;
            background: #fafafa;
            padding-top: 20px;
            padding-bottom: 30px;
          }
        }
        &:hover {
          cursor: pointer;
          &::after {
            position: absolute;
            content: "";
            width: 100%;
            height: 4px;
            background-color: #043c83;
            bottom: 0;
            left: 0;
          }
          > div.submenu_wrapper {
            display: block;
          }
        }
      }
    }
  }
}
.serarch-box {
  width: 198px !important;
  height: 46px !important;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-left: 60px;
  color: white;
  font-size: 18px;
  background-image: url("../assets/img2/head_search_black_bg.png");
}
.search-sticked-box {
  background-image: url("../assets/img2/head_search_bg.png") !important;
}
</style>
